import { CalendarCheck, CalendarDays, Ellipsis, Sun, Users } from "lucide-react";
import type { TabItem } from "@web/ui";

export const TABS = [
  { key: "today", label: "Today", icon: Sun, path: "/today" },
  { key: "leads", label: "Leads", icon: Users, path: "/leads" },
  { key: "calendar", label: "Calendar", icon: CalendarDays, path: "/calendar" },
  { key: "bookings", label: "Bookings", icon: CalendarCheck, path: "/bookings" },
  { key: "more", label: "More", icon: Ellipsis, path: "/more" },
] as const satisfies readonly (TabItem & { path: string })[];

export type TabKey = (typeof TABS)[number]["key"];

export function tabForPath(pathname: string) {
  return TABS.find((t) => pathname === t.path || pathname.startsWith(`${t.path}/`));
}

/** NavBar title and back target for screens that are not tabs. */
const PAGES: Array<{ match: RegExp; title: string; back: string }> = [
  { match: /^\/tours$/, title: "Tours", back: "/more" },
  { match: /^\/events$/, title: "Events", back: "/more" },
  { match: /^\/bookings\/[^/]+$/, title: "Booking", back: "/bookings" },
  { match: /^\/leads\/[^/]+$/, title: "Lead", back: "/leads" },
  { match: /^\/more\/queue$/, title: "Review queue", back: "/more" },
  { match: /^\/more\/messages$/, title: "Messages", back: "/more" },
  { match: /^\/more\/messages\/[^/]+$/, title: "Conversation", back: "/more/messages" },
  { match: /^\/more\/accounting$/, title: "Accounting", back: "/more" },
  { match: /^\/more\/commissions$/, title: "Commissions", back: "/more" },
  { match: /^\/settings$/, title: "Settings", back: "/more" },
  { match: /^\/settings\/company$/, title: "Company", back: "/settings" },
  { match: /^\/settings\/venues$/, title: "Venues", back: "/settings" },
  { match: /^\/settings\/catalog$/, title: "Catalog", back: "/settings" },
  { match: /^\/settings\/event-types$/, title: "Event types", back: "/settings" },
  { match: /^\/settings\/lead-sources$/, title: "Lead sources", back: "/settings" },
  { match: /^\/settings\/users$/, title: "Users", back: "/settings" },
  { match: /^\/settings\/api-keys$/, title: "API keys", back: "/settings" },
  { match: /^\/settings\/contract-templates$/, title: "Contract templates", back: "/settings" },
  { match: /^\/settings\/message-templates$/, title: "Message templates", back: "/settings" },
  { match: /^\/settings\/drip-sequences$/, title: "Drip sequences", back: "/settings" },
  { match: /^\/settings\/automation$/, title: "Automation", back: "/settings" },
  { match: /^\/settings\/calendar$/, title: "Calendar", back: "/settings" },
  { match: /^\/settings\/payments$/, title: "Payments", back: "/settings" },
  { match: /^\/contracts\/[^/]+\/countersign$/, title: "Countersign", back: "/bookings" },
];

export function pageMeta(pathname: string): { title: string; back?: string; tab: TabKey } {
  const tab = tabForPath(pathname);
  if (tab && pathname === tab.path) return { title: tab.label, tab: tab.key };
  const page = PAGES.find((p) => p.match.test(pathname));
  return { title: page?.title ?? "venue365", back: page?.back ?? "/more", tab: tab?.key ?? "more" };
}
